import React from "react";
import { useNetworkStatus } from "@src/providers/NetworkStatusProvider";

const OFFLINE_MESSAGE = "You're offline (changes may not save)";

export default function OfflineBanner(): React.JSX.Element | null {
  const { isOnline } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      role="alert"
      className="offline-banner width-100 text-center text-sm font-weight-bold"
    >
      {OFFLINE_MESSAGE}
    </div>
  );
}
